import { InjectionToken, Type } from '@angular/core';

export const BELL_ICON_COMPONENT_TOKEN = new InjectionToken<Type<never>>('BellIconComponent');
